// Polna · wspólne zachowania kart produktu i podstron: pasek ogłoszeń (marquee), menu pełnoekranowe z atramentem, ryciny, akordeony.
// Strona główna ma te same efekty w sklep.js i v4.js (1:1 z home-sklep v5).
import 'polna/koszyk';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const root = document.documentElement;
root.classList.add('js');

/* pasek ogłoszeń: druga kopia grupy = pętla bez szwu */
$$('.annc .mq').forEach(mq => {
  const track = $('.mq-track', mq), g = $('.mq-group', track);
  const minW = Math.max(innerWidth, 1600), base = g.innerHTML; let guard = 0;
  while (g.scrollWidth < minW && guard++ < 6) g.insertAdjacentHTML('beforeend', base);
  const copy = g.cloneNode(true); copy.setAttribute('aria-hidden', 'true'); track.appendChild(copy);
  track.style.setProperty('--mq-dur', `${Math.round(g.scrollWidth / Number(mq.dataset.speed || 40))}s`);
});

/* ryciny w sekcjach: dopiero przy zbliżeniu */
const artIO = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); artIO.unobserve(e.target); } }), { rootMargin: '60px 0px' });
$$('.sec-art').forEach(el => artIO.observe(el));

/* obrazy sekcji poniżej pierwszego ekranu: data-src ładowane tuż przed pokazaniem (lżejszy pierwszy ekran) */
const lzIO = new IntersectionObserver(es => es.forEach(e => { if (!e.isIntersecting) return; const i = e.target; if (!i.dataset.src) { lzIO.unobserve(i); return; } if (i.dataset.srcset) i.srcset = i.dataset.srcset; i.src = i.dataset.src; i.removeAttribute('data-src'); lzIO.unobserve(i); }), { rootMargin: '120px 0px' });
$$('img[data-src]').forEach(i => lzIO.observe(i));

/* odsłanianie .rv */
const rvIO = new IntersectionObserver(es => es.forEach(e => { if (!e.isIntersecting) return; e.target.classList.add('in'); rvIO.unobserve(e.target); }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
$$('.rv').forEach(el => rvIO.observe(el));

/* akordeony z płynnym otwieraniem (ta sama animacja co FAQ strony głównej: details + grid 0fr/1fr) */
$$('.acc details').forEach(d => {
  const sum = $('summary', d), a = $('.acc-a', d); if (!a) return;
  if (d.open) d.classList.add('is-open');
  sum.addEventListener('click', e => {
    e.preventDefault();
    if (reduced) { d.open = !d.open; d.classList.toggle('is-open', d.open); return; }
    if (!d.open) { d.open = true; requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-open'))); }
    else {
      d.classList.remove('is-open');
      const done = ev => { if (ev && ev.target !== a) return; a.removeEventListener('transitionend', done); clearTimeout(t); if (!d.classList.contains('is-open')) d.open = false; };
      const t = setTimeout(done, 450); a.addEventListener('transitionend', done);
    }
  });
});

/* menu pełnoekranowe (jak v4.js strony głównej) */
const fmenu = $('#fmenu'), menuBtn = $('[data-menu]');
let fx = null, menuOpen = false, closeT = 0;
const inkReady = () => {
  if (fx || !window.InkCornerReveal) return fx;
  try { fx = window.InkCornerReveal.create($('.fmenu-ink', fmenu), { inkColor: [30 / 255, 58 / 255, 43 / 255], paperColor: null, corner: 'tr', edge: 0.03, maxDpr: 1.5, reducedMotion: reduced }); }
  catch { fx = null; }
  return fx;
};
function openMenu() {
  if (!fmenu || menuOpen) return;
  menuOpen = true; clearTimeout(closeT);
  fmenu.hidden = false; fmenu.classList.remove('is-closing'); root.classList.add('menu-lock');
  menuBtn?.setAttribute('aria-expanded', 'true');
  const f = inkReady(); if (f) f.to('full', reduced ? 0.001 : 1.0); else fmenu.style.background = '#1E3A2B';
  requestAnimationFrame(() => requestAnimationFrame(() => fmenu.classList.add('is-open')));
  setTimeout(() => $('.fmenu-close', fmenu)?.focus({ preventScroll: true }), reduced ? 0 : 400);
}
function closeMenu(focusBack = true) {
  if (!fmenu || !menuOpen) return;
  menuOpen = false; fmenu.classList.remove('is-open'); fmenu.classList.add('is-closing');
  menuBtn?.setAttribute('aria-expanded', 'false');
  closeT = setTimeout(() => { if (fx) fx.to('rest', reduced ? 0.001 : 0.7); }, reduced ? 0 : 220);
  setTimeout(() => { if (!menuOpen) { fmenu.hidden = true; fmenu.classList.remove('is-closing'); root.classList.remove('menu-lock'); } }, reduced ? 0 : 1000);
  if (focusBack) menuBtn?.focus({ preventScroll: true });
}
if (fmenu) {
  menuBtn?.addEventListener('click', () => (menuOpen ? closeMenu() : openMenu()));
  $('[data-menu-close]', fmenu).addEventListener('click', () => closeMenu());
  document.addEventListener('keydown', e => {
    if (!menuOpen) return;
    if (e.key === 'Escape') closeMenu();
    if (e.key === 'Tab') {
      const f = $$('a, button', fmenu), first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  addEventListener('resize', () => { if (menuOpen && innerWidth > 900) closeMenu(false); });
}

/* formularz kontaktowy i newsletter: bez wysyłki, tylko komunikat */
$$('form[data-local]').forEach(f => f.addEventListener('submit', e => {
  e.preventDefault();
  const msg = $('[data-msg]', f);
  if (!f.checkValidity()) { msg.textContent = f.dataset.err || 'Uzupełnij wymagane pola.'; f.reportValidity?.(); return; }
  msg.textContent = f.dataset.ok || 'Dziękujemy.'; f.reset();
}));
